import { Serializable } from '@admin/core/models/serializable';
import { FeatureModel } from './feature-model';

export class PermissionModel implements Serializable<PermissionModel> {
  fromObject(object: any): PermissionModel {
    Object.assign(this, object);

    this.features = [];

    if (
      object.features &&
      object.features.length &&
      object.features.length > 0
    ) {
      object.features.forEach((el) => {
        let t = new FeatureModel();
        t = t.fromObject(el);
        this.features.push(t);
      });
    }

    return this;
  }

  toObject() {
    throw new Error('Not Implemented');
  }

  public featureType: number;
  public features: FeatureModel[];

  constructor() {
    this.featureType = null;
    this.features = [];
  }
}
